module.exports = __webpack_public_path__ + "img/yml_main0.350022e3.jpg";